/**
 * Based on https://en.wikipedia.org/wiki/Point_%28typography%29
 * There are 72 points per inch; if it is sufficient to assume 96 pixels per inch
 * @param {number} pixels
 * @returns number
 */
export const pixelsToPoints = (pixels) => (pixels * 72) / 96;
